import { PushType } from "@seneca/notifications-service-types";

import { isAndroid, isIOS } from "features/common/utils/functions/mobile";

export default function getPushType(): PushType {
  if (isIOS()) return "push-ios";
  if (isAndroid()) return "push-android";
  return "push-web";
}
